module.exports = "<div id=\"address-box-wrapper\">\n\n    <div class=\"box-header\">\n        <div class=\"headerText\">{{header}}</div>\n        <div class=\"updateButton\">\n            <a ng-click=\"updateFn()\">{{updateType}}</a>\n        </div>\n    </div>\n    <div class=\"box-body\">\n        <p ng-if=\"name\">{{name}}</p>\n        <p>{{address.line1}}</p>\n        <p>{{address.line2}}</p>\n        <p>{{line3}}</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/address-box/template.html
// module id = ../node_modules/xo-ui-components/src/address-box/template.html
// module chunks = 0